



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class FileIcon extends Vue {
  @Prop({ required: true }) fileName: string;
  
  get isImage(){
    return this.fileName.match(/\.(jpg|jpeg|gif)$/i)
  }
  get isPng(){
    return this.fileName.match(/\.(png)$/i)
  }
  get isZip(){
    return this.fileName.match(/\.(zip)$/i)
  }
}
